import { Check, ClipboardCopy } from "lucide-react";
import { Button } from "./Button";

export function CommandBlock({
  command,
  copyValue,
  field,
  copiedField,
  onCopy,
  wrap = false,
  className = "",
}: {
  command: string;
  copyValue?: string;
  field: string;
  copiedField: string | null;
  onCopy: (command: string, field: string) => void;
  wrap?: boolean;
  className?: string;
}) {
  return (
    <div className={className}>
      <div className="relative">
        <code
          className={`block rounded-md border border-muted bg-surface py-3 pr-12 pl-3 text-sm ${wrap ? "break-all whitespace-pre-wrap" : "overflow-x-auto whitespace-pre"}`}
        >
          {command}
        </code>
        <Button
          variant="secondary"
          size="icon"
          onClick={() => onCopy(copyValue ?? command, field)}
          aria-label={copiedField === field ? "Copied" : "Copy command"}
          title={copiedField === field ? "Copied" : "Copy command"}
          className="absolute top-[7px] right-[7px]"
        >
          {copiedField === field ? (
            <Check className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
          ) : (
            <ClipboardCopy
              className="h-4 w-4"
              strokeWidth={1.8}
              aria-hidden="true"
            />
          )}
        </Button>
      </div>
    </div>
  );
}
